import { render, staticRenderFns } from "./platformManagementForm.vue?vue&type=template&id=43c7a288"
import script from "./platformManagementForm.vue?vue&type=script&lang=js"
export * from "./platformManagementForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports